export { default as enumsAddress } from "./address";
export { default as enumsPayment } from "./payment";
export { default as enumsSchedule } from "./schedule";
export { default as enumsSetting } from "./settings";
export { default as enumsSubscription } from "./subscription";
export { default as enumsCashback } from "./cashback";
export { default as enumsAccountsReceivable } from "./accountsReceivable";
export { default as enumsPoll } from './poll'

export const VideoFrequencyStatus = Object.freeze({
  STARTED: 'I',
  PAUSED: 'P',
  FINISHED: 'F',
  WATCHED: '1',
  // Add other statuses as needed
})
